import api from "../config/api";
import type { ApiResponse, PaginatedResponse } from "../types";

// ServiceBonus Types
export interface ServiceBonus {
  _id: string;
  name: string;
  status: 'active' | 'inactive';
  price: number;
  note: number;
  createdAt: string;
  updatedAt: string;
}

// Request Interfaces
export interface CreateServiceBonusRequest {
  name: string;
  status?: 'active' | 'inactive';
  price: number;
  note: number;
}

export interface UpdateServiceBonusRequest extends Partial<CreateServiceBonusRequest> {}

export interface UpdateServiceBonusStatusRequest {
  status: 'active' | 'inactive';
}

export interface GetServiceBonusParams {
  page?: number;
  limit?: number;
  status?: string;
  name?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}


// Room Service
export const serviceBonusService = {
  // ดึงรายการห้องทั้งหมด
  getServiceBonuses: async (params: GetServiceBonusParams = {}): Promise<PaginatedResponse<ServiceBonus>> => {
    const response = await api.get('/service-bonuses', { params });
    return response.data;
  },

  // ดึงข้อมูลห้องตาม ID
  getServiceBonus: async (id: string): Promise<ApiResponse<ServiceBonus>> => {
    const response = await api.get(`/service-bonuses/${id}`);
    return response.data;
  },

  // สร้างห้องใหม่
  createServiceBonus: async (data: CreateServiceBonusRequest): Promise<ApiResponse<ServiceBonus>> => {
    const response = await api.post('/service-bonuses', data);
    return response.data;
  },

  // ແກ້ໄຂข้อมูลห้อง
  updateServiceBonus: async (id: string, data: UpdateServiceBonusRequest): Promise<ApiResponse<ServiceBonus>> => {
    const response = await api.put(`/service-bonuses/${id}`, data);
    return response.data;
  },

  // ลบห้อง
  deleteServiceBonus: async (id: string): Promise<ApiResponse<ServiceBonus>> => {
    const response = await api.delete(`/service-bonuses/${id}`);
    return response.data;
  },

  // ແກ້ໄຂสถานะห้อง
  updateServiceBonusStatus: async (id: string, data: UpdateServiceBonusStatusRequest): Promise<ApiResponse<ServiceBonus>> => {
    const response = await api.patch(`/service-bonuses/${id}/status`, data);
    return response.data;
  },


};